import React from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import {withFormik} from 'formik';
import {object, string, boolean} from 'yup';
import Button from "@material-ui/core/Button";

import i18n from '../../i18n';
import {mergeWithDefault} from "../Form/utils";
import FormField from '../Form/FormField';
import FormSelect from "../Form/FormSelect";
import FormCheck from "../Form/FormCheck";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import FormIntervalFields from "../Form/Partials/IntervalFields";

const InnerForm = ({
   values,
   errors,
   attributeGroups,
   categoryOptions,
   intervalUnits,
   keys,
   units,
   rates,
   touched,
   setFieldValue,
   setFormikState,
   handleChange,
   handleBlur,
   handleSubmit,
   isSubmitting
}) => (
    <form onSubmit={handleSubmit}>
        <FormSelect
            name="attribute_group_id"
            label={i18n.get('attribute.form.group')}
            error={errors.attribute_group_id}
            touched={touched.attribute_group_id}
            onChange={selectedOption =>
                setFieldValue(
                    "attribute_group_id",
                    selectedOption.value
                )
            }
            onBlur={handleBlur}
            options={
                [{_id: '', id: '', name_chain: 'root ▶ '}]
                    .concat(attributeGroups)
                    .map(group => ({value: group.id, label: group.name_chain}))
            }
            value={values.attribute_group_id}
        />

        <FormField
            label={i18n.get('attribute.form.name')}
            type="text"
            name="name"
            error={errors.name}
            touched={touched.name}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.name}
        />

        <FormCheck
            name="required"
            label={i18n.get('attribute.form.required')}
            error={errors.required}
            touched={touched.required}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.required}
        />

        {categoryOptions && (
            <React.Fragment>
                <Typography variant="subtitle1" component="div">
                    {i18n.get('attribute.life_cycle_rate_category')}
                </Typography>
                {categoryOptions.map(({label, value}, idx) => {
                    return value > 0 && (
                        <Grid container key={`category${idx}`}>
                            <Grid item xs={6}>
                                <FormSelect
                                    key={idx}
                                    name={`life_cycle_rate[${value}]`}
                                    label={label}
                                    error={errors.categories}
                                    touched={touched.categories}
                                    onChange={(target) => {
                                        values.categories[value]["lifeCycleRate"] = target.value ? target.value : null;
                                        setFormikState({values});
                                    }}
                                    onBlur={handleBlur}
                                    options={
                                        [{value: '', label: i18n.get('default.select.none')}]
                                            .concat(rates)
                                            .map(rate => ({value: rate.id, label: rate.name}))
                                    }
                                    value={values.categories[value]["lifeCycleRate"]}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                    <FormIntervalFields
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        values={values.categories[value]}
                                        intervalUnits={intervalUnits}
                                        setFieldValue={(key, targetValue) => {
                                            values.categories[value][key] = targetValue;
                                            setFormikState({values});
                                        }}
                                        touched={touched}
                                    />
                            </Grid>
                        </Grid>

                    )
                })}
            </React.Fragment>
        )}

        <FormCheck
            name="isAllocatableCost"
            label={i18n.get('attribute.form.isAllocatableCost')}
            error={errors.isAllocatableCost}
            touched={touched.isAllocatableCost}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.isAllocatableCost}
        />

        <FormSelect
            name="entity_unit"
            label={i18n.get('attribute.form.unit')}
            error={errors.entity_unit}
            touched={touched.entity_unit}
            onChange={({entity}) => {
                setFieldValue("entity_quantity", entity.class);
                setFieldValue("entity_unit", entity.unit)
            }}
            onBlur={handleBlur}
            options={units.map((value) => ({label: value.name, value: value.unit, entity: value}))}
            value={values.entity_unit}
        />

        <Button
            disabled={isSubmitting}
            variant="contained"
            color="primary"
            type="submit"
        >
            {i18n.get('attribute.submit')}
        </Button>
    </form>
);

const categoriesDefault = (categoryOptions) => {
    let res = {};
    categoryOptions.map((item) => {
        res[item.value] = {lifeCycleRate: null, interval: null, interval_unit: null};
    });
    return res;
};

const AttributeForm = withFormik({
    mapPropsToValues: props => {
        /** @namespace props.categoryOptions */
        return mergeWithDefault(props.values, {
            key: '',
            name: '',
            required: false,
            isOperatingCost: false,
            isAllocatableCost: false,
            entity_quantity: '',
            entity_unit: '',
            categories: categoriesDefault(props.categoryOptions),
            interval_value: '',
            interval_unit: 0,
            category: 0,
        });
    },
    validationSchema: object().shape({
        name: string()
            .required(i18n.get('validation.required', {attribute: i18n.get('attribute.form.name')})),
        required: boolean(),
    }),
    handleSubmit: (values,
                   {
                       props,
                       setSubmitting,
                       setErrors,
                   }) => {
        setSubmitting(true);

        axios({
            method: props.method,
            url: props.url,
            data: values,
        })
            .then(response => {
                setSubmitting(false);
                let data = response.data;


                // Show success message.
                return swal({
                    text: i18n.get('attribute.saved.success'),
                    icon: "success",
                }).then(() => {
                    if ( data.forward ) {
                        window.location.href = data.forward;
                    }
                });
            })
            .catch(error => {
                setSubmitting(false);

                if (error.response && error.response.data && error.response.data.errors) {
                    setErrors(error.response.data.errors);
                }

                // Show error message.
                return swal({
                    text: i18n.get('attribute.saved.error'),
                    icon: "error",
                });
            });
    },
})(InnerForm);

export default AttributeForm;



// WEBPACK FOOTER //
// ./resources/assets/js/components/Attribute/Form.js